import React, { useState } from 'react'
import commonStyles from "../AssignMemberCommon.styles";
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import BasicCard from '../../../../../components/card/basiccard/BasicCard';
import styles from "./AssignedMembersConfirmation.styles"
import Payer from '../../../../../../libs/utility/Payer';
import { useSelector } from 'react-redux';
import { componentKey as authenticationKey } from '../../../../authentication/AuthenticationSlice';

const USER_CONFIRMATION_OPTIONS = [{ title: "Assigning to all 3 users works!" }, { title: "No, I want to change this" }];

const AssignedMembersConfirmation = () => {

    const { setSignedInUser } = useSelector(state => state[authenticationKey])
    const [selectedOption, setSelectedOption] = useState();

    return (
        <>
            <div style={commonStyles.formContainer}>
                <Heading type={HEADING.H1}>{`We have assigned all 3 member users to ${setSignedInUser?.FirstName || ""}. Does this work for you?`}</Heading>

                <div style={styles.optionsContainer}>

                    {USER_CONFIRMATION_OPTIONS.map((option, idx) => (
                        <div onClick={() => Payer.handleSelectOptionClick(idx, setSelectedOption)}>
                            <BasicCard
                                customStyles={styles.optionCard}
                                circularCheckboxStyles={styles.circularCheckbox}
                                isHighlighted={selectedOption === idx ? true : false}
                            >
                                <p style={styles.optionLabel}>{option.title}</p>
                            </BasicCard>
                        </div>
                    ))}

                </div>
            </div>
        </>
    )
}

export default AssignedMembersConfirmation